import { useAtomValue } from "jotai";
import {
  DefaultNodeData,
  tableUsageAsyncAtomFamily,
  tablesUsageAsyncAtom,
} from "@zapier/canvas-state";
import RecordProgress from "./RecordProgress";

interface TableUsageProps {
  tableId: DefaultNodeData["tableId"];
}

export function TableUsage({ tableId }: TableUsageProps) {
  const tableUsage = useAtomValue(tableUsageAsyncAtomFamily(tableId));
  const tablesUsage = useAtomValue(tablesUsageAsyncAtom);

  if (!tableUsage || !tablesUsage) {
    return null;
  }

  const { recordCount } = tableUsage;

  return (
    <RecordProgress
      numberOfRecords={recordCount}
      limit={tablesUsage.maxRecordsCount}
    />
  );
}
